export const itData = {
  title: 'Informativa sulla Privacy e sui Cookie – Danghuan',
  sections: [
    {
      title: 'Introduzione',
      content: `
        <p>La presente Informativa sulla Privacy e sui Cookie descrive come Danghuan Europe S.L. ('noi', 'ci' o 'Danghuan') raccoglie, utilizza e protegge i tuoi dati personali quando interagisci con i nostri siti web e servizi. Questa politica si applica ai residenti dello Spazio Economico Europeo (SEE) e del Regno Unito (UK), ed è conforme al Regolamento generale sulla protezione dei dati (GDPR) e alla versione UK del GDPR.</p>
      `
    },
    {
      title: 'Scope of this Policy',
      content: `
        <p>La presente Politica si applica a:</p>
        <ul>
          <li>Visitatori del nostro sito web</li>
          <li>Clienti e potenziali clienti</li>
          <li>Utenti dei nostri servizi di permuta e rivendita</li>
          <li>Rappresentanti di partner commerciali e affiliati di piattaforme</li>
        </ul>
      `
    },
    {
      title: 'What Data We Collect',
      content: `
        <p>A seconda della tua interazione con noi, potremmo raccogliere:</p>
        <ul>
          <li>Nome completo, indirizzo, e-mail e numero di telefono</li>
          <li>IBAN, codice bancario, numero di conto, dati PayPal, Revolut o altre coordinate bancarie</li>
          <li>Dati del dispositivo (modello, marca, condizione, prezzo, IMEI)</li>
          <li>Cronologia delle comunicazioni con il servizio clienti</li>
          <li>Preferenze di marketing e interazioni con campagne promozionali</li>
          <li>Indirizzo IP, tipo di browser, ID di sessione e posizione</li>
          <li>Dati di piattaforme come Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Potremmo anche ricevere alcuni dati su di te dai nostri partner di piattaforma o logistici (es. Shopify, Amazon, BackMarket, TEMU) quando interagisci con le loro piattaforme in relazione ai nostri servizi. Questi dati includono informazioni sugli ordini, indirizzi di spedizione e stato delle transazioni.</p>
      `
    },
    {
      title: 'Use of Personal Data',
      content: `
        <p>Utilizziamo i tuoi dati per:</p>
        <ul>
          <li>Gestire ordini e logistica (inclusi resi e permute)</li>
          <li>Comunicare con te in merito alle tue transazioni</li>
          <li>Fornire assistenza clienti e supporto tecnico</li>
          <li>Inviare comunicazioni di marketing (previo consenso)</li>
          <li>Rispettare obblighi legali (es. segnalazioni fiscali o controlli antifrode)</li>
          <li>Migliorare l'esperienza utente e ottimizzare le nostre piattaforme</li>
        </ul>
      `
    },
    {
      title: 'Cookies',
      content: `
        <p>Utilizziamo i cookie per migliorare la tua esperienza di navigazione e i nostri servizi. I cookie possono raccogliere:</p>
        <ul>
          <li>Indirizzo IP e geolocalizzazione</li>
          <li>Identificatori del browser o del dispositivo</li>
          <li>Comportamento di utilizzo (pagine visitate, tempo sul sito, clic effettuati)</li>
        </ul>
        <p>Tipi di cookie utilizzati:</p>
        <ul>
          <li>Cookie strettamente necessari</li>
          <li>Cookie funzionali</li>
          <li>Cookie di performance</li>
          <li>Cookie pubblicitari</li>
        </ul>
        <p>Puoi configurare o revocare le tue preferenze relative ai cookie in qualsiasi momento tramite il browser o il banner dei cookie.</p>
      `
    },
    {
      title: 'Third Parties We Share Data With',
      content: `
        <p>Condividiamo i dati con partner di pagamento e logistica quando è necessario per adempiere a un contratto; e con fornitori di analisi solo con il tuo consenso espresso per i cookie.</p>
        <p>Potremmo condividere i tuoi dati con:</p>
        <ul>
          <li>Partner di pagamento: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li>Corrieri logistici: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li>Piattaforme partner: Shopify, Amazon, TEMU, Back Market</li>
          <li>Fornitori di marketing e analisi: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li>Fornitori IT, consulenti, consulenti legali</li>
          <li>Autorità pubbliche se richiesto dalla legge</li>
        </ul>
        <p>I dati possono essere trasferiti al di fuori dello SEE/UK secondo le clausole contrattuali standard approvate dall'UE.</p>
      `
    },
    {
      title: 'Use of Third-Party Brand Logos',
      content: `
        <p>Il nostro sito mostra nomi e loghi di marchi come Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google e altri, esclusivamente per identificare dispositivi compatibili con i nostri servizi di permuta o rivendita. Tutti i marchi sono di proprietà dei rispettivi titolari. Danghuan Europe è un fornitore indipendente e non è affiliato né sponsorizzato da tali marchi, salvo diversamente specificato.</p>
        <p>L'uso dei loghi di terze parti è esclusivamente a fini descrittivi. Tutti i diritti sui marchi sono riservati e non si intende suggerire alcuna associazione con Danghuan.</p>
      `
    },
    {
      title: 'Data Retention and Security',
      content: `
        <p>Conserviamo i tuoi dati solo per il tempo necessario a soddisfare le finalità sopra indicate o come previsto dalla legge. Applichiamo misure tecniche e organizzative adeguate per proteggere i dati, inclusi crittografia, controllo degli accessi e archiviazione sicura.</p>
      `
    },
    {
      title: 'Your Rights',
      content: `
        <p>Ci impegniamo a rispondere a tutte le richieste valide entro un mese. Per proteggere la tua privacy, potremmo richiedere una verifica dell'identità prima di procedere.</p>
        <p>Hai diritto a:</p>
        <ul>
          <li>Accedere e rettificare i tuoi dati</li>
          <li>Richiedere la cancellazione ('diritto all'oblio')</li>
          <li>Oporre o limitare il trattamento</li>
          <li>Revocare il consenso in qualsiasi momento</li>
          <li>Richiedere la portabilità dei dati (ove applicabile)</li>
        </ul>
        <p>Per esercitare tali diritti, contattaci a <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: 'Policy Updates',
      content: `
        <p>Potremmo aggiornare questa informativa per riflettere modifiche normative o delle nostre pratiche. L'ultima versione sarà sempre disponibile sul nostro sito web.</p>
      `
    },
    {
      title: 'Contact Us',
      content: `
        <p>Per domande o per esercitare i tuoi diritti, puoi contattarci:</p>
        <ul>
          <li>Danghuan Europe S.L.</li>
          <li>Email: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li>Sito web: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Puoi anche presentare un reclamo alla tua autorità locale per la protezione dei dati o all'Agenzia Spagnola per la Protezione dei Dati (AEPD).</p>
      `
    },
    {
      title: 'Addendum – Extended Legal and Cookie Information',
      subsections: [
        {
          title: '1. Legal Basis for Data Processing',
          content: `
            <p>La base giuridica per il trattamento dei tuoi dati personali include:</p>
            <ul>
              <li>Esecuzione di un contratto (es. elaborazione di ordini di permuta, invio di pagamenti)</li>
              <li>Adempimento di obblighi legali (es. dichiarazioni fiscali, verifica dell'identità)</li>
              <li>Il tuo consenso (es. comunicazioni di marketing o cookie di terze parti)</li>
              <li>Interessi legittimi (es. prevenzione delle frodi, analisi interne, miglioramento dei servizi)</li>
            </ul>
          `
        },
        {
          title: '2. Fraud Prevention Measures',
          content: `
            <p>Potremmo utilizzare le tue informazioni personali (es. numero di serie del dispositivo, modello di transazione, geolocalizzazione IP, titolarità dell'IBAN) per condurre attività di rilevamento frodi utilizzando database pubblici e fornitori di servizi antifrode. Questo avviene in virtù del nostro interesse legittimo a prevenire furti di identità e usi impropri dei nostri servizi.</p>
            <p>Non prendiamo decisioni basate esclusivamente su processi automatizzati che possano avere effetti significativi su di te.</p>
          `
        },
        {
          title: '3. Data Handling on External Marketplaces',
          content: `
            <p>Se acquisti o vendi dispositivi tramite piattaforme di terze parti come Amazon, Shopify, TEMU o Back Market, Danghuan Europe può ricevere informazioni relative all'ordine, indirizzo di spedizione e conferma del pagamento tramite API crittografate o canali interni sicuri, esclusivamente per evadere l'ordine e fornire assistenza post-vendita.</p>
          `
        },
        {
          title: '4. Cookie Categories and Details',
          content: `
            <p>Puoi consultare l'elenco completo dei cookie che utilizziamo — inclusi nome, fornitore, finalità, durata e tipologia (cookie di prima o terza parte) — nella tabella sottostante. Questo include cookie analitici di Google Analytics, cookie di remarketing di Meta e cookie di pagamento di PayPal.</p>
            <table>
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Nome del cookie</th>
                  <th>Fornitore</th>
                  <th>Finalità</th>
                  <th>Durata</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Necessari</td>
                  <td>OptanonConsent</td>
                  <td>danghuan.eu</td>
                  <td>Memorizza le preferenze sul cookie</td>
                  <td>1 anno</td>
                  <td>Prima parte</td>
                </tr>
                <tr>
                  <td>Necessari</td>
                  <td>session_id</td>
                  <td>danghuan.eu</td>
                  <td>Mantiene lo stato della sessione</td>
                  <td>Sessione</td>
                  <td>Prima parte</td>
                </tr>
                <tr>
                  <td>Funzionali</td>
                  <td>LiBnext</td>
                  <td>danghuan.eu</td>
                  <td>Ricorda la lingua selezionata</td>
                  <td>Sessione</td>
                  <td>Prima parte</td>
                </tr>
                <tr>
                  <td>Funzionali</td>
                  <td>live_chat</td>
                  <td>Tawk.to</td>
                  <td>Abilita la chat dal vivo con il supporto</td>
                  <td>6 mesi</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Prestazioni</td>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>Raccoglie statistiche sull'utilizzo del sito</td>
                  <td>2 anni</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Prestazioni</td>
                  <td>_gld</td>
                  <td>Google Analytics</td>
                  <td>Traccia il comportamento dell'utente</td>
                  <td>24 ore</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Prestazioni</td>
                  <td>_clck</td>
                  <td>Microsoft Clarity</td>
                  <td>Mantiene la sessione dell'utente</td>
                  <td>1 anno</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Pubblicitari</td>
                  <td>_fbp</td>
                  <td>Meta (Facebook)</td>
                  <td>Fornisce annunci personalizzati</td>
                  <td>3 mesi</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Pubblicitari</td>
                  <td>_tt_enable_cookie</td>
                  <td>TikTok</td>
                  <td>Traccia conversioni e interazioni</td>
                  <td>13 meses</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Pubblicitari</td>
                  <td>_uetsid</td>
                  <td>Bing</td>
                  <td>Traccia l'utente tra siti</td>
                  <td>1 giorno</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Pubblicitari</td>
                  <td>_gtl_au</td>
                  <td>Google Ads</td>
                  <td>Utilizzato per il monitoraggio delle conversioni</td>
                  <td>3 mesi</td>
                  <td>Terza parte</td>
                </tr>
                <tr>
                  <td>Pubblicitari</td>
                  <td>_klu_</td>
                  <td>Klaviyo</td>
                  <td>Identifica i visitatori per il marketing via email</td>
                  <td>2 anni</td>
                  <td>Terza parte</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: '5. Promotions, Campaigns and Surveys',
          content: `
            <p>Quando partecipi a promozioni, sondaggi o concorsi, potremmo raccogliere il tuo nome, i tuoi recapiti e ulteriori informazioni specifiche per l'evento (es. età, località). Tali dati vengono utilizzati esclusivamente per gestire l'evento, contattare i vincitori e migliorare future iniziative.</p>
          `
        },
        {
          title: '6. Supervisory Authorities',
          content: `
            <p>Puoi presentare un reclamo alle seguenti autorità di controllo se ritieni che i tuoi diritti in materia di protezione dei dati siano stati violati:</p>
            <ul>
              <li>In Spagna: <strong>Agencia Española de Protección de Datos (AEPD)</strong> – <a href="https://www.aepd.es" target="_blank">www.aepd.es</a></li>
              <li>Nel Regno Unito: <strong>Information Commissioner's Office (ICO)</strong> – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
              <li>Nell'Unione Europea: puoi trovare l'autorità nazionale competente per il tuo paese nel sito del <strong>Comitato Europeo per la Protezione dei Dati (EDPB)</strong> – <a href="https://edpb.europa.eu/about-edpb/board/members_it" target="_blank">https://edpb.europa.eu/about-edpb/board/members_it</a></li>
            </ul>
          `
        }
      ]
    }
  ],
  footer: `
    <p>© 2025 DANGHUAN EUROPE S.L. Tutti i diritti riservati.<br>
    Versione della politica: v1.0 | Ultimo aggiornamento: 30/05/2025</p>
  `
};